import { ActionType } from '@editor/src/js/constants/common-action-type';
import { AuthFeature } from '@framework/workbench/ui/auth/auth-feature';
import { authMenu, MENU_CONFIGS, transferAuth, usePrivateAuthMenu } from '@framework/workbench/ui/auth/config';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { Controller, Menu } from '@tencent/workbench';

@Controller({ menuItems: MENU_CONFIGS })
export class AuthController {
    public constructor(private readonly feature: AuthFeature) {}

    @Menu(ActionType.PERMISSION_MENU, 'popUpStyle')
    public popupStyle() {
        return {
            width: '194px',
        };
    }

    @Menu(ActionType.PERMISSION_MENU, 'shouldHide')
    public shouldHide() {
        return !authMenu || !SlideDataServices.DocInfoManager()?.isOwner || !!usePrivateAuthMenu;
    }

    @Menu(ActionType.PERMISSION_MENU, 'shouldDisabled')
    public shouldDisabled() {
        return !SlideDataServices.PrivilegeManager()?.getPrivilegeAttribute().can_view_priv_setting;
    }

    @Menu(ActionType.PERMISSION_SETTING, 'onClick')
    public permissionSetting() {
        this.feature.permissionSetting();
    }

    @Menu(ActionType.PERMISSION_SETTING, 'shouldHide')
    public shouldHidePermissionSetting() {
        if (!usePrivateAuthMenu) return false;
        return !window.basicClientVars?.authInfo?.attribute?.canViewPrivSetting;
    }

    @Menu(ActionType.ADVANCED_PERMISSION, 'onClick')
    public advancedPermission() {
        this.feature.advancedPermission();
    }

    @Menu(ActionType.SET_WATER_MARK, 'onClick')
    public setWatermark() {
        this.feature.setWatermark();
    }

    @Menu(ActionType.TRANSFER_OWNERSHIP, 'onClick')
    public transferAuth() {
        this.feature.transferAuth();
    }

    @Menu(ActionType.TRANSFER_OWNERSHIP, 'shouldHide')
    public shouldTransferAuthHide() {
        return !transferAuth;
    }
}
